var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-answer quiz-answer-tiles",on:{"click":_vm.updateState}},[_c('img',{staticClass:"quiz-answer-cover",style:({
        'background-image': ("url(" + (_vm.answer.cover_url || '') + ")"),
      }),attrs:{"src":_vm.EMPTY_IMAGE,"alt":_vm.answer.title || ''}}),_c('div',{staticClass:"quiz-answer-title"},[_vm._v(" "+_vm._s(_vm.answer.title || '')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }